<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              사용자 등록
            </div>
          </section>
          <section class="section02">
            <div class="object01"></div>
            <div class="object02"></div>
            <div class="object03">
              상태
            </div>
            <div class="object04">
              <ul>
                <li class="active">
                  <label>
                    <input type="radio" v-model="status" value="ACTIVE"/>
                    <i></i>
                    <span>활성화</span>
                  </label>
                </li>
                <li class="inactive">
                  <label>
                    <input type="radio" v-model="status" value="PASSIVE"/>
                    <i></i>
                    <span>비활성화</span>
                  </label>
                </li>
              </ul>
            </div>
            <div class="object05"></div>
            <div class="object06"></div>
            <div class="object07">
              아이디
            </div>
            <div class="object08">
              <input type="text" v-model="userId"/>
            </div>
            <div class="object09"></div>
            <div class="object10"></div>
            <div class="object11">
              비밀번호
            </div>
            <div class="object12">
              <input type="text" v-model="userPw"/>
            </div>
            <div class="object13"></div>
            <div class="object14"></div>
            <div class="object15">
              비밀번호 확인
            </div>
            <div class="object16">
              <input type="text" v-model="userPw2"/>
            </div>
            <div class="object17"></div>
            <div class="object18"></div>
            <div class="object19">
              이름
            </div>
            <div class="object20">
              <input type="text" v-model="userName" />
            </div>
            <div class="object21"></div>
            <div class="object22">
              휴대폰
            </div>
            <div class="object23">
              <input class="no-arrow" type="number" v-model="userPhone"/>
            </div>
            <div class="object24"></div>
            <div class="object25">
              이메일
            </div>
            <div class="object26">
              <input type="text" v-model="userEmail"/>
            </div>
            <div class="object27"></div>
            <div class="object28"></div>
            <div class="object29">
              권한
            </div>
            <div class="object30">
              <div class="formSelect" ref="select01" @click="openSelect01">
                <div class="formSelectList">
                  <input type="text" :value="findRoleName(userRole)"  placeholder="권한을 선택하세요." readonly />
                </div>
                <div class="formSelectPopup select01">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="권한을 선택하세요." v-model="searchRoleValue" @keyup="changeRoleValue" />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li v-for="selectUserRole in selectUserRoleList" :key="selectUserRole.roleCode">
                                <label>
                                  <input type="radio" v-model="userRole" :value="selectUserRole.roleCode" />
                                  <input type="checkbox"/>
                                  <i></i>
                                  <span>{{ selectUserRole.roleName }}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="object31"></div>
            <div class="object32"></div>
            <div class="object33">
              담당 골프클럽
            </div>
            <div class="object34">
              <div class="formSelect" ref="select02">
                <div class="formSelectList" @click="openSelect02">
                  <input type="text" :value="findClubName(ccode)" placeholder="담당 골프클럽을 선택하세요." readonly />
                </div>

                <div class="formSelectPopup typeSearch select02">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="검색어를 입력하세요." v-model="searchValue" v-on:keyup="changeSearchValue" />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li v-for="club_info in selectClubInfoList" :key="club_info.ccode" @click="closeSelectAll">
                                <label>
                                  <input type="radio" v-model="ccode" :value="club_info.ccode"/>
                                  <input type="checkbox"/>
                                  <i></i>
                                  <span>{{club_info.club_name}}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="club-list">
                <div v-for="ccode in ccodes" :key="ccode" class="club-item" @click="() => onClubCodeDelete(ccode)">
                  <!-- Club name -->
                  {{ findClubName(ccode) }}
                  <!-- Close icon -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 26 26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                </div>
              </div>
            </div>
            <!-- 툴팁 활성 : tooltipActive -->
            <div class="object35" :class="tooltipActive ? 'tooltipActive' : ''"  @click="openTooltip" ref="tooltip">
              <div class="tooltip">
                [설정 > 골프클럽 관리]에서 활성화 상태로 설정된 골프클럽 목록입니다.
              </div>
            </div>
          </section>
          <section class="section03">
            <div class="object01">
              <button class="cancel" @click="moveMenu('/MA001')">
                취소
              </button>
            </div>
            <div class="object02">
              <!-- 비활성(Attribute) : disabled -->
              <button class="registration" @click="postData" :disabled="!passValidation">
                등록
              </button>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertBodyHTML">
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      취소
                    </button>
                    <button class="confirm" @click="closeAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="권한을 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="selectUserRole in selectUserRoleList" :key="selectUserRole.roleCode" @click="closeSelectAll">
                      <label>
                        <input type="radio" v-model="userRole" :value="selectUserRole.roleCode" />
                        <input type="checkbox"/>
                        <i></i>
                        <span>{{ selectUserRole.roleName }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup typeSearch select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." v-model="searchValue" v-on:keyup="changeSearchValue" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="club_info in selectClubInfoList" :key="club_info.ccode" @click="closeSelectAll">
                      <label>
                        <input type="radio" v-model="ccode" :value="club_info.ccode"/>
                        <input type="checkbox"/>
                        <i></i>
                        <span>{{club_info.club_name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { phoneNumberTester } from '../libs/useRegExp'
import { aplManagerService, clubInfoService } from '../router'
import FooterLayout from './layout/Footer.vue'
import HeaderLayout from './layout/Header.vue'
import LeftLayout from './layout/Left.vue'

export default {
  name: 'MA003',
  data () {
    return {
      status: 'ACTIVE',
      userId: '',
      userPw: '',
      userPw2: '',
      userName: '',
      userPhone: '',
      userEmail: '',
      userRole: '',
      ccode: '',
      ccodes: [],
      active_checked: true,
      not_active_checked: false,
      html_object: {},
      userRoleList: [
        {
          roleCode: 'AplManager',
          roleName: 'APL관리자'
        },
        {
          roleCode: 'AplMaster',
          roleName: 'APL마스터'
        },
        {
          roleCode: 'ClubManager',
          roleName: '클럽관리자'
        },
        {
          roleCode: 'AplDeveloper',
          roleName: 'APL개발자'
        },
        {
          roleCode: 'SktDeveloper',
          roleName: 'SKT개발자'
        }
      ],
      selectUserRoleList: [],
      searchRoleValue: '',
      clubInfoList: [],
      resTotalNotice: {
        statusCode: null,
        data: {
          accountCnt: 0,
          accountList: []
        }
      },
      PageNo: 1,
      PageSize: 1,
      authority: '',
      search_word: '',
      account_id: '',
      alertBodyHTML: '',
      callback: null
    }
  },
  created: function () {
    this.selectUserRoleList = this.userRoleList
    clubInfoService.getClubInfoList('active').then(response => {
      this.clubInfoList = response.data.clubInfoList
      this.selectClubInfoList = response.data.clubInfoList
    }).catch(error => {
      console.log('getClubInfoListByStatusActive.err.===>', error)
    })
  },
  mounted: function () {
    // 랜덤 비밀번호 입력
    this.userPw = this.userPw2 = this.randomPassword()
  },
  computed: {
    passValidation: function () {
      if (!this.status) return false
      if (!this.userId) return false
      if (!this.userPw) return false
      if (!this.userPw2) return false
      if (!this.userName) return false
      if (!this.userRole) return false
      if (((this.userRole === 'ClubManager')) && (!this.ccode)) return false
      if (this.userPhone) return phoneNumberTester().test(this.userPhone)
      return true
    }
  },
  methods: {
    /**
     * 클럽 코드를 목록에 추가합니다.
     * @param {string} clubCode
     */
    addClubCode(clubCode) {
      this.ccodes = [...this.ccodes, clubCode]
    },
    /**
     * 클럽 코드를 목록에서 제거합니다.
     * @param {string} clubCode
     */
    removeClubCode(clubCode) {
      this.ccodes = this.ccodes.filter((code) => code !== clubCode)
    },
    findRoleName: function (userRole) {
      if (this.userRoleList.find(it => it.roleCode === userRole) !== undefined) {
        return this.userRoleList.find(it => it.roleCode === userRole).roleName
      } else {
        return ''
      }
    },
    changeRoleValue: function () {
      this.selectUserRoleList = this.userRoleList.filter(it => it.roleName.includes(this.searchRoleValue))
    },
    findClubName: function (ccode) {
      if (this.clubInfoList.find(it => it.ccode === ccode) !== undefined) {
        return this.clubInfoList.find(it => it.ccode === ccode).club_name
      } else {
        return ''
      }
    },
    moveMenu: function (path) {
      this.$router.push(path)
    },
    postData: function () {
      let AccountId = this.account_id
      if (this.userPw !== this.userPw2) {
        this.openAlert('비밀번호와 비밀번호 확인은<br />같아야 합니다.')
        return
      }
      aplManagerService.postManagementUserRegistration(this.status, this.userId, this.userPw, this.userName, this.userPhone, this.userEmail, this.userRole, this.ccode, this.ccodes).then(response => {
        // this.resTotalNotice = response.data
        if (response.statusCode === 500) {
          this.openAlert('중복된 아이디가 있습니다.')
        } else {
          this.PageNo = 1
          this.PageSize = 1
          this.status = ''
          this.authority = ''
          this.search_word = ''
          // alert(1)
          aplManagerService.getSummaryManagementUserList(this.PageNo, this.PageSize, this.status, this.authority, this.search_word).then(response => {
            this.resTotalNotice = response.data
            this.resTotalNotice.accountList.forEach(function (item) {
              // console.log('item.account_id' + item.account_id)
              AccountId = item.account_id
            })
            // alert(2)
            // console.log('this.resTotalNotice.accountList.account_id=' + this.resTotalNotice.accountList)
            this.openAlert('등록되었습니다.', function () {
              this.moveMenu('/MA002?account_id=' + AccountId)
            })
          }).catch(error => {
            console.log('getSummaryManagementUserList.err.===>', error)
          })
        }
      }).catch(error => {
        console.log('getTotalNotice.err.===>', error)
      })
    },
    openAlert: function (html, cb = null) {
      this.alertBodyHTML = html
      this.callback = cb
      document.querySelector('body.type-content').classList.add('alertActive')
    },
    closeAlert: function () {
      this.alertBodyHTML = ''
      document.querySelector('body.type-content').classList.remove('alertActive')
      if (this.callback === null) return
      this.callback()
      this.callback = null
    },
    randomPassword: function () {
      let pw = ''
      let alphabet = 'abcdefghijklmnopqrstuvwxyz'
      for (let i = 0; i < 2; i++) {
        pw += alphabet.charAt(Math.floor(Math.random() * alphabet.length))
      }
      let randomNumber = String(Math.random()).substr(2, 6)
      pw += randomNumber
      return pw
    },

    /**
     * @param {string} clubCode
     */
    onClubCodeDelete(clubCode) {
      this.removeClubCode(clubCode)
    }
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },

  watch: {
    ccode(value) {
      const isIncluded = this.ccodes.includes(value)
      if (!isIncluded) this.addClubCode(value)
    }
  }
}
</script>

<style scoped>
.object34 {
  display: flex;
  align-items: center;
  gap: 20px;
}

.club-list {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.7);
}

.club-list .club-item {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 4px 6px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MA003.vue